import { Scope } from '@unform/core'

import Panel from '~/components/Panel'
import { FormGroup, Radio } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import ScreensGroups from '../../../ScreensGroups'

export default function Screens({ handleFormChange, formRef }: ScreensProps) {
  const { t } = useAPPTranslation()

  const optionsTypes: RadioOptionProps[] = [
    {
      id: `placesCheck_all`,
      value: 'all',
      label: t('rm:campaign.create.Screens.options.all.label'),
      description: t('rm:campaign.create.Screens.options.all.description')
    },
    {
      id: `placesCheck_selected`,
      value: 'selected',
      label: t('rm:campaign.create.Screens.options.selected.label'),
      description: t('rm:campaign.create.Screens.options.selected.description'),
      activeChildren: (
        <ScreensGroups handleFormChange={handleFormChange} formRef={formRef} />
      )
    }
  ]

  return (
    <Panel
      title={t('rm:campaign.create.Screens.title')}
      description={t('rm:campaign.create.Screens.description')}
    >
      <Scope path="places">
        <FormGroup>
          <Radio options={optionsTypes} name="placesCheck" required />
        </FormGroup>
      </Scope>
    </Panel>
  )
}
